import React from 'react'

const FavoriteActiveIcon = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 23 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.4421 1.9252L11.9087 4.85853C12.1087 5.26686 12.6421 5.65853 13.0921 5.73353L15.7504 6.1752C17.4504 6.45853 17.8504 7.69186 16.6254 8.90853L14.5587 10.9752C14.2087 11.3252 14.0171 12.0002 14.1254 12.4835L14.7171 15.0419C15.1837 17.0669 14.1087 17.8502 12.3171 16.7919L9.82541 15.3169C9.37541 15.0502 8.63375 15.0502 8.17541 15.3169L5.68375 16.7919C3.90041 17.8502 2.81708 17.0585 3.28375 15.0419L3.87541 12.4835C3.98375 12.0002 3.79208 11.3252 3.44208 10.9752L1.37541 8.90853C0.158746 7.69186 0.550413 6.45853 2.25041 6.1752L4.90875 5.73353C5.35041 5.65853 5.88375 5.26686 6.08375 4.85853L7.55041 1.9252C8.35041 0.333529 9.65041 0.333529 10.4421 1.9252Z'
        fill='#F4B313'
      />
    </svg>
  )
}

export default FavoriteActiveIcon
